import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-accordion-page',
    templateUrl: './showroom-exhibit-accordion-page.component.html',
    styleUrls: ['./showroom-exhibit-accordion-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitAccordionPageComponent {

}
